"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONVERSATIONAL_SEARCH_RESULTS_EVENT_SCHEMA_ID = exports.BASE_EVENT_SCHEMA_ID = exports.AVAILABILITY_TYPES = void 0;
const BASE_EVENT_SCHEMA_ID = exports.BASE_EVENT_SCHEMA_ID = 'urn:shared:user:events:/v1';
const CONVERSATIONAL_SEARCH_RESULTS_EVENT_SCHEMA_ID = exports.CONVERSATIONAL_SEARCH_RESULTS_EVENT_SCHEMA_ID = 'urn:shared:user:event:/serp/conversational-search-results/v1';
const AVAILABILITY_TYPES = exports.AVAILABILITY_TYPES = {
  availablePrimaryBaseTier: 'available_primary_base_tier',
  availablePrimaryRegPremiumTier: 'available_primary_reg_premium_tier',
  availableAftermarketPremium: 'available_aftermarket_premium',
  availableAftermarketAuction: 'available_aftermarket_auction',
  availablePreRegistration: 'available_pre_registration',
  takenDbs: 'taken_dbs',
  takenNoDbs: 'taken_no_dbs',
  smartMatch: 'smart_match',
  unavailable: 'unavailable'
};